//----------------------------------------
//--------- Commerce7 Utilities ----------
//----------------------------------------

/**
 * Fetch vivino score using vivino link and vintage
 *
 * @param {string} vivinoUrl Link to the wine on Vivino.com
 * @param {number} wineVintage Vintage of the wine
 */
const getVivinoScore = (vivinoUrl, wineVintage, score, isDetailsPage) => {
	if (!vivinoUrl || !wineVintage) {
		return false;
	}

	const found = vivinoUrl.match(/\/w\/(\d+)\??/);

	if (!found) {
		return false;
	}

	const vivinoId = found[1];
	const url = `https://api.vivino.com/wines/${vivinoId}`;
	$.ajax({
		type: "GET",
		url: theme_object.ajax_url,
		data: { action: "get_vivino_score", 'vivinoUrl' : url, 'vintage' : wineVintage },
		async: false,
		success: function (response) {
			if (response && response['ratings_average']) {
				score.innerHTML = renderStars(
					response['ratings_count'],
					response['ratings_average'],
					vivinoUrl,
					isDetailsPage
				);
				$(score).addClass("show");
			}
		},
		error: function (err) {
			console.log(err);
		},
	});
};

/**
 *
 * @param {integer} ratingsCount Ratings count
 * @param {float} ratingsAverage Ratings average between [0, 5]
 * @param {url} vivinoUrl Link to the wine on Vivino.com
 * @param {boolean} isDetailsPage Whether detail page or not
 */
const renderStars = (
	ratingsCount,
	ratingsAverage,
	vivinoUrl = "",
	isDetailsPage
) => {
	const stars = Array(5)
		.fill()
		.map((_, index) => {
			const width =
				index <= ratingsAverage - 1
					? 100
					: index <= ratingsAverage
					? parseInt((ratingsAverage * 100) % 100)
					: 0;
			return `<i class="star star-under icon-star">
            <i class="star star-over icon-star" style="width: ${width}%"></i>
        </i>`;
		})
		.join("");

	const vivinoSiteLink = isDetailsPage
		? `&nbsp;<a target="_blank" rel="noopener noreferrer" href="${vivinoUrl}">on Vivino.com</a>`
		: "";

	return `<div class="rating-container">
        <span class="icon-vivino"></span>
        <div class="stars-container">
            ${stars}
        </div>
        <div class="rating-score">${ratingsAverage} | ${ratingsCount} Ratings${vivinoSiteLink}</div>
    </div>`;
};

/**
 * Render rating stars in place of vivino link and vintage text.
 *
 * @param {Node} container Wine data Wrapper
 * @param {Boolean} isDetailsPage Whether wine detail page or not
 */
export const renderVivinoScore = (container, isDetailsPage = false) => {
	$(container)
		.find(".c7-product__vivino-score")
		.each((_, score) => {
			const vivinoUrl = $(score).find(".link").text().trim();
			const vintage = $(score).find(".vintage").text().trim();
			getVivinoScore(vivinoUrl, vintage, score, isDetailsPage);
		});
};
